/* eslint-disable css-modules/no-unused-class  */
import { Divider, Icon, ProgressIndicator } from 'learning-panel-components';
import { FC } from 'react';
import { translate } from 'translations';
import moment from 'moment';
import styles from './resultCard.module.scss';

const ResultsCard: FC<ResultsCardProps> = (props: ResultsCardProps) => {
    const { name, roundNumber, totalRounds, totalQuestions, correctQuestions, scheduledDate, answers } = props;

    const getDetail = (title: string, value: string) => {
        return (
            <div className={styles.detail}>
                <div className={styles.title}>{title}</div>
                <div className={styles.value}>{value}</div>
            </div>
        );
    };

    return (
        <div className={styles['results-wrapper']}>
            <div className={styles.top}>
                <div className={styles['title-wrapper']}>
                    <Icon name="tournamentResultsIcon" />
                    <div className={styles.title}>{name}</div>
                    <Divider orientation="vertical" className={styles.divider} color="rgba(255, 255, 255, 0.2)" />
                    <div className={styles.time}>
                        {translate('OccurredOn')} {moment(scheduledDate).format('MMM DD ,YYYY')}
                    </div>
                </div>
                <div className={styles.details}>
                    {getDetail(translate('Round'), `${roundNumber} ${translate('of')} ${totalRounds}`)}
                    <div className={styles.line} />
                    {getDetail(translate('AnswersRate'), `${correctQuestions}/${totalQuestions}`)}
                </div>
            </div>
            <Divider orientation="horizontal" className={styles.divider} color="rgba(255, 255, 255, 0.2)" />
            <div className={styles.answers}>
                <table>
                    <thead>
                        <tr>
                            <th>{translate('QuestionNo.')}</th>
                            <th>{translate('Vulnerability')}</th>
                            <th>{translate('Result')}</th>
                            <th>{translate('AnsweredCorrectly')}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {answers.map((answer, i) => (
                            <tr key={i}>
                                <td className={styles['centered-column']}>
                                    <div className={styles['question-number']}>{i + 1}</div>
                                </td>
                                <td className={styles['answer-text']}>
                                    {answer.vulnerabilityName ?? translate('General')}
                                </td>
                                <td> {<Icon name={answer.correct ? 'correct' : 'incorrect'} />} </td>
                                <ProgressIndicator direction="horizontal" value={answer.allUsersSuccess} />
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export interface ResultsCardProps {
    name: string;
    totalQuestions: number;
    correctQuestions: number;
    scheduledDate: Date;
    roundNumber: number;
    totalRounds: number;
    answers: ResultsCardAnswer[];
}

interface ResultsCardAnswer {
    vulnerabilityName: string;
    correct: boolean;
    allUsersSuccess: number;
}
export default ResultsCard;
